
export class Client {
  firstname: string;
  lastname: string;
  email: string;
  room: string;
  id: string;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/model/client.ts